import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { HoverData } from '../models/hover-data';

@Directive({
    selector: '[appHover]'
})
export class HoverDirective {
    constructor(private el: ElementRef) {}

    @Input() set appHover(config: HoverData) {
        this.classes = config?.classList?.split(' ') || [];
    }

    classes: string[] = [];

    @HostListener('mouseenter') onMouseover() {
        if (this.el && this.classes) {
            for (const userClass of this.classes) {
                userClass && this.el.nativeElement.classList.add(userClass);
            }
        }
    }

    @HostListener('mouseleave') onMouseleave() {
        //drop logic
        if (this.el && this.classes) {
            for (const userClass of this.classes) {
                userClass && this.el.nativeElement.classList.remove(userClass);
            }
        }
    }
}
